import { useState, useEffect } from "react";
import axios from "axios";
import { getTokenCookie } from "../../../views/Login/cookie";
import HeaderLogoIcon from "../../components/headerLogoIcons/headerLogoIcons";
import { FooterIndex } from "../../components";
import "./profileUser.css";

const ProfileUserL = () => {
  const [dataProfile, setDataProfile] = useState({});
  const [load, setLoad] = useState(true);

  useEffect(() => {
    async function fetchData() {
      // Obtiene el token desde las cookies
      const token = getTokenCookie();

      // Hace la petición incluyendo el token como un parámetro de consulta
      const response = await axios.get(
        `${process.env.REACT_APP_PROFILE_ADMIN}${token}`
      );

      setLoad(false);
      setDataProfile(response.data);
    }
    fetchData();
  }, []);

  return (
    <div className="heighvh">
      <HeaderLogoIcon />
      {!load ? (
        <div className="box-profile">
          <div>
            <p className="tittle-pro">Perfil</p>
          </div>
          <div className="box-profile-display">
            <div className="box-info-profile">
              <p className="info-text-tittle">Nombre:</p>
              <div>
                <p className="info-text-profile">{dataProfile.name}</p>
              </div>
            </div>
            <div className="box-info-profile">
              <p className="info-text-tittle">Apellido:</p>
              <p className="info-text-profile">{dataProfile.lastName}</p>
            </div>
          </div>
          <div className="box-profile-display">
            <div className="box-info-profile">
              <p className="info-text-tittle">Celular:</p>
              <p className="info-text-profile"> {dataProfile.phone}</p>
            </div>
            <div className="box-info-profile">
              <p className="info-text-tittle">Cuil:</p>
              <p className="info-text-profile">{dataProfile.cuil}</p>
            </div>
          </div>
          <div className="box-profile-display">
            <div className="box-info-profile">
              <p className="info-text-tittle">Email:</p>
              <p className="info-text-profile">{dataProfile.email}</p>
            </div>
          </div>
        </div>
      ) : (
        <div className="loader"></div>
      )}

      <FooterIndex />
    </div>
  );
};

export default ProfileUserL;
